import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/image/logo.png";
import { navigation } from "./_nav";

const TheSidebar = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [childActiveIndex, setChildActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setChildActiveIndex(null);
  };

  return (
    <div className="sidebar-main bg-white">
      <Link to="/" className="sidebar-brand">
        <img src={logo} alt="Logo" />
        <span className="brand-title">Apeejay Education</span>
      </Link>
      <ul
        className="accordion accordion-flush sidebar-item-parent"
        id="accordionFlushExample"
      >
        {navigation.map((item, index) => (
          <li className={`accordion-item bottom-border`} key={index}>
            <div className="accordion-header" id={`flush-heading${index}`}>
              {item.children && item.children.length > 0 ? (
                <span
                  title={item.label}
                  className={`accordion-button ${
                    activeIndex !== index ? "collapsed" : ""
                  }`}
                  type="button"
                  onClick={() => handleToggle(index)}
                  aria-expanded={activeIndex === index}
                  aria-controls={`flush-collapse${index}`}
                >
                  {item.name}
                </span>
              ) : (
                <Link
                  title={item.label}
                  to={item.to}
                  className="accordion-button collapsed no-caret"
                >
                  {item.name}
                </Link>
              )}
            </div>
            {item.children && item.children.length > 0 && (
              <div
                id={`flush-collapse${index}`}
                className={`accordion-collapse collapse ${
                  activeIndex === index ? "show" : ""
                }`}
                aria-labelledby={`flush-heading${index}`}
                data-bs-parent="#accordionFlushExample"
              >
                {item.children.map((child, childIndex) => (
                  <div
                    className={`accordion-body bottom-border ${
                      childIndex === childActiveIndex
                        ? "active-sidebar-child-item"
                        : ""
                    }`}
                    key={childIndex}
                  >
                    <Link
                      title={child.label}
                      to={child.to}
                      onClick={() => setChildActiveIndex(childIndex)}
                    >
                      <span className="show">{child.name}</span>
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TheSidebar;
